import { isRSC, isServer, useIsomorphicLayoutEffect } from "@tamagui/constants";
import { startTransition, useState } from "react";
function useDidFinishSSR() {
  if (isServer || isRSC) {
    return false;
  }
  const [did, setDid] = useState(false);
  useIsomorphicLayoutEffect(() => {
    startTransition(() => {
      setDid(true);
    });
  }, []);
  return did;
}
export {
  useDidFinishSSR
};
//# sourceMappingURL=index.js.map
